/* bejesa-attribution-capture.js v9 — v8 IC fix + last-touch attribution (merged 2026-06-14).
   Captures gclid/fbclid/UTM from URL → cart attributes (Shopify-persisted).
   Fires ATC + IC events to AdLens VPS for real-funnel analytics.
   AdLens endpoint configurable via window.__ADLENS_URL__ (set by theme inject).

   v6 (2026-05-17): IC was 0/day because /checkouts/c/<token> is rendered by
   Shopify CE — theme.liquid JS never runs there. Fix: intercept click/submit
   on storefront BEFORE leaving to checkout. Three signals + 3s dedup.
   v7 (2026-05-18): IC fired in-browser but never reached the server —
   Content-Type:application/json triggers a CORS preflight (OPTIONS) that the
   browser cancels when the checkout click navigates away. Fix: send /track as
   text/plain (simple request, no preflight). Server parses with force=True.
   v8 (2026-05-18): getCookieVal regex '\s' footgun → manual split parser.
   v9 (2026-06-14): LAST-TOUCH attribution — a new ad click (gclid/fbclid/
   utm_source) resets the whole bj_* set and writes only that click's channel,
   so a stale Google UTM never mixes with a later Facebook click. Window 90d→30d.
   ATC fetch/XHR/submit interception and the v8 IC detection are UNCHANGED. */
(function () {
  'use strict';

  var ADLENS = (typeof window.__ADLENS_URL__ === 'string' && window.__ADLENS_URL__)
                || 'https://attribution.srv1258154.hstgr.cloud';

  function getParam(name) {
    var m = window.location.search.match(new RegExp('[?&]' + name + '=([^&]+)'));
    return m ? decodeURIComponent(m[1]) : null;
  }
  function getCookieVal(name) {
    var pairs = (document.cookie || '').split(';');
    for (var i = 0; i < pairs.length; i++) {
      var kv = pairs[i].trim();
      var eq = kv.indexOf('=');
      if (eq <= 0) continue;
      if (kv.slice(0, eq) === name) {
        try { return decodeURIComponent(kv.slice(eq + 1)); }
        catch (e) { return kv.slice(eq + 1); }
      }
    }
    return null;
  }

  var paramsToCapture = ['gclid','fbclid','utm_source','utm_medium','utm_campaign','utm_content','utm_term','ttclid','twclid'];

  function buildAttrs() {
    var attrs = {};
    paramsToCapture.forEach(function (p) {
      var v = getParam('bj_' + p) || getParam(p) || getCookieVal('bj_' + p);
      if (v) attrs['bj_' + p] = v;
    });
    if (Object.keys(attrs).length > 0) {
      // v10 (2026-09-28): the visitor id joins the cart attributes, so AdLens can tie
      // the order to this visitor's earlier ad touches (assisted attribution). Only
      // when attribution is present: no extra /cart/update.js calls for plain visits.
      attrs['bj_vid'] = getAdLensVisitorId();
      attrs['bj_landing'] = window.location.pathname + window.location.search;
      attrs['bj_referrer'] = document.referrer || '(direct)';
      attrs['bj_first_seen'] = new Date().toISOString();
    }
    return attrs;
  }

  function getAdLensVisitorId() {
    // Fully guarded: storage/cookie access can throw in blocked/private-mode
    // browsers; this function must NEVER throw into a click/submit handler.
    try {
      var match = document.cookie.match(/ab_visitor=([^;]+)/);
      if (match) return decodeURIComponent(match[1]);
      var existing = localStorage.getItem('bj_adlens_vid');
      if (existing) return existing;
      var fresh = 'v_' + Math.random().toString(36).slice(2, 12) + Date.now().toString(36);
      try { localStorage.setItem('bj_adlens_vid', fresh); } catch (e) {}
      return fresh;
    } catch (e) {
      return 'v_' + Math.random().toString(36).slice(2, 12) + Date.now().toString(36);
    }
  }

  // ── Last-touch attribution with reset (market standard, v9) ───────────────
  // A NEW ad click (URL carries any ENTRY SIGNAL — gclid/fbclid/ttclid/twclid/
  // utm_source) is a fresh touch: CLEAR the whole bj_* set, then write ONLY this
  // click's params. Stops a stale Google UTM mixing with a later Facebook click.
  // A visit with no ad params (organic/direct) leaves cookies intact (last touch).
  // Window 30 days. PURE cookie writes — no fetch, no cart interaction.
  var ATTR_WINDOW_DAYS = 30;
  var ENTRY_SIGNALS = ['gclid','fbclid','ttclid','twclid','utm_source'];
  function urlHasEntrySignal() {
    for (var i = 0; i < ENTRY_SIGNALS.length; i++) {
      if (getParam('bj_' + ENTRY_SIGNALS[i]) || getParam(ENTRY_SIGNALS[i])) return true;
    }
    return false;
  }
  try {
    if (urlHasEntrySignal()) {
      var maxAge = ATTR_WINDOW_DAYS * 24 * 60 * 60;
      paramsToCapture.forEach(function (p) {
        var v = getParam('bj_' + p) || getParam(p);
        if (v) {
          document.cookie = 'bj_' + p + '=' + encodeURIComponent(v) + ';path=/;max-age=' + maxAge + ';samesite=lax';
        } else {
          document.cookie = 'bj_' + p + '=;path=/;max-age=0;samesite=lax';   // clear stale, different-channel value
        }
      });
    }
    // else: organic/direct — keep existing last-touch attribution cookies.
  } catch (e) {}

  function pushCartAttrs() {
    var attrs = buildAttrs();
    if (Object.keys(attrs).length === 0) return;
    return fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ attributes: attrs })
    }).catch(function () {});
  }

  function fireAdLensEvent(eventType) {
    var attrs = buildAttrs();
    var payload = {
      event_type: eventType,
      visitor_id: getAdLensVisitorId(),
      fbclid: attrs['bj_fbclid'] || null,
      utm_campaign: attrs['bj_utm_campaign'] || null,
      utm_term: attrs['bj_utm_term'] || null,
      utm_content: attrs['bj_utm_content'] || null,
      landing_url: attrs['bj_landing'] || window.location.pathname,
    };
    // text/plain blob → sendBeacon ships immediately without CORS preflight,
    // survives page navigation. Server uses get_json(force=True).
    try {
      var blob = new Blob([JSON.stringify(payload)], { type: 'text/plain;charset=UTF-8' });
      if (navigator.sendBeacon && navigator.sendBeacon(ADLENS + '/track', blob)) return;
    } catch (e) {}
    fetch(ADLENS + '/track', {
      method: 'POST',
      headers: { 'Content-Type': 'text/plain;charset=UTF-8' },
      body: JSON.stringify(payload),
      keepalive: true,
    }).catch(function () {});
  }

  // IC dedup: a single checkout click can hit BOTH the button-name=checkout listener
  // AND the form-submit listener (form contains the button). 3s window is enough.
  var lastICFired = 0;
  function fireICOnce(source) {
    var now = Date.now();
    if (now - lastICFired < 3000) return;
    lastICFired = now;
    try { console.log('[bj-attribution] IC fired via', source); } catch (e) {}
    fireAdLensEvent('initiate_checkout');
  }

  // ── PageView attribution → cart attrs ─────────────────────────
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', pushCartAttrs);
  } else {
    pushCartAttrs();
  }
  ['cart:added','cart:updated','cart:refresh'].forEach(function (ev) {
    document.addEventListener(ev, pushCartAttrs);
  });

  // ── ATC capture (3 paths: fetch, XHR, form submit) ────────────
  var origFetch = window.fetch;
  window.fetch = function (url) {
    var p = origFetch.apply(this, arguments);
    var urlStr = typeof url === 'string' ? url : (url && url.url) || '';
    if (urlStr.indexOf('/cart/add') !== -1) {
      p.then(function (resp) {
        if (resp && resp.ok) {
          setTimeout(pushCartAttrs, 200);
          fireAdLensEvent('add_to_cart');
        }
      });
    }
    return p;
  };

  document.addEventListener('submit', function (e) {
    var f = e.target;
    if (!f || !f.action) return;
    if (f.action.indexOf('/cart/add') !== -1) {
      setTimeout(function () { fireAdLensEvent('add_to_cart'); }, 100);
    }
    // IC: any form whose action is /checkout or /checkouts/...
    if (f.action.indexOf('/checkout') !== -1) {
      fireICOnce('form-submit');
    }
  }, true);

  try {
    var XHRopen = XMLHttpRequest.prototype.open;
    var XHRsend = XMLHttpRequest.prototype.send;
    XMLHttpRequest.prototype.open = function (method, url) {
      this.__bj_url = typeof url === 'string' ? url : '';
      return XHRopen.apply(this, arguments);
    };
    XMLHttpRequest.prototype.send = function () {
      var xhr = this;
      var url = xhr.__bj_url || '';
      if (url.indexOf('/cart/add') !== -1) {
        xhr.addEventListener('load', function () {
          if (xhr.status >= 200 && xhr.status < 300) {
            setTimeout(pushCartAttrs, 200);
            fireAdLensEvent('add_to_cart');
          }
        });
      }
      return XHRsend.apply(this, arguments);
    };
  } catch (e) {}

  // ── IC capture (v6 fix) ───────────────────────────────────────
  // Capture-phase click — walks up from target looking for any of:
  //   - <button name="checkout">           (standard Shopify cart form)
  //   - <a href="/checkout" | "/checkouts/...">
  //   - .shopify-payment-button__button    (dynamic Buy-it-now)
  //   - .shopify-payment-button__more-options
  // PASSIVE: never preventDefault/stopPropagation — cannot affect the cart or
  // checkout click. Bounded DOM walk (depth 8). Wrapped against throws.
  document.addEventListener('click', function (e) {
    try {
      var el = e.target;
      var depth = 0;
      while (el && el.nodeType === 1 && depth < 8) {
        if (el.tagName === 'BUTTON' && el.getAttribute('name') === 'checkout') {
          return fireICOnce('button[name=checkout]');
        }
        if (el.tagName === 'A') {
          var href = el.getAttribute('href') || '';
          if (href === '/checkout' || href.indexOf('/checkout?') === 0 || href.indexOf('/checkouts/') !== -1) {
            return fireICOnce('a[href=/checkout]');
          }
        }
        if (el.classList && (
          el.classList.contains('shopify-payment-button__button') ||
          el.classList.contains('shopify-payment-button__more-options')
        )) {
          return fireICOnce('shopify-payment-button');
        }
        el = el.parentNode;
        depth++;
      }
    } catch (e2) { /* never let tracking interfere with the click */ }
  }, true);

  // Last-resort fallback (dead on CE but cheap — useful if Shopify reverts).
  var pn = window.location.pathname;
  if (pn.indexOf('/checkouts/') !== -1 || pn.indexOf('/checkout/') !== -1 || pn === '/checkout') {
    fireICOnce('pathname-fallback');
  }

  // Safety retry for cart-attrs push
  setTimeout(pushCartAttrs, 3000);

  console.log('[bj-attribution v10] active (last-touch + IC click/text-plain + visitor id in cart). AdLens:', ADLENS);
})();
